var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.ishui ? "qzhui" : "qz" },
    [
      _c(_vm.menutop, { tag: "component", attrs: { islan: _vm.islan } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "allcontent", attrs: { id: "aa1" } },
        [
          _c(_vm.mainPage, {
            tag: "component",
            attrs: {
              idd: _vm.idd,
              search: _vm.search,
              page: _vm.page,
              searchtype: _vm.searchtype
            }
          }),
          _vm._v(" "),
          _c("BOTTOM")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 329
// module chunks = 34